import { Order } from "@/domain/order.model";
import { IPaginateVueTable } from "@/interfaces/IPaginateVueTable";

export default {
  orders: (state): IPaginateVueTable<Order> => state.orders,
  order: (state): Order => state.order,
  isLoading: (state): boolean => state.isLoading,
  isCreating: (state): boolean => state.isCreating,
  isUpdating: (state): boolean => state.isUpdating,
  isDeleting: (state): boolean => state.isDeleting,
};
